export const CONFIG = {
  GOOGLE_SHEETS_WEBHOOK_URL: import.meta.env.VITE_GOOGLE_SHEETS_WEBHOOK_URL || '',
  SYNC_TOKEN: 'ssccore',
};
